import * as moment from 'moment';

export function getStartOfDay(date) {
    const momentDate = moment(date);
    if (momentDate.isValid()) {
        return momentDate.startOf('day').toDate();
    }

    return null;
}
export function getEndOfDay(date) {
    const momentDate = moment(date);
    if (momentDate.isValid()) {
        return momentDate.endOf('day').toDate();
    }

    return null;
}

export default {
    getStartOfDay,
    getEndOfDay,
};
